import type { NexoModule } from './types';

export const modules: NexoModule[] = [
  {
    id: 'radar-fiscal', name: 'Radar Fiscal 360', shortName: 'Radar Fiscal', icon: 'ScanSearch', accent: 'emerald', category: 'Fiscalização',
    tagline: 'Encontre o risco antes da inspecção.',
    description: 'Cruza movimentos, facturas e sinais de inconsistência para criar um mapa de risco fiscal explicável.',
    features: ['Mapa de risco por evidência', 'Detecção de duplicados', 'Plano de fiscalização'],
    promptStarters: ['Priorize as cinco anomalias mais críticas', 'Crie um roteiro de verificação para esta entidade', 'Explique as divergências sem assumir fraude'],
    accepted: '.csv,.json,.txt,.md,.pdf,.png,.jpg,.jpeg,.webp', outputLabel: 'Parecer de risco'
  },
  {
    id: 'reconcilia-ao', name: 'Reconcilia AO', shortName: 'Reconcilia', icon: 'GitCompareArrows', accent: 'blue', category: 'Controlo',
    tagline: 'Conciliação que mostra o porquê.',
    description: 'Organiza extractos, lançamentos e comprovativos, destacando diferenças e propondo correspondências auditáveis.',
    features: ['Correspondência inteligente', 'Tolerâncias configuráveis', 'Trilho de reconciliação'],
    promptStarters: ['Agrupe movimentos possivelmente correspondentes', 'Liste valores sem contrapartida', 'Prepare uma nota de conciliação executiva'],
    accepted: '.csv,.json,.txt,.md,.pdf,.png,.jpg,.jpeg', outputLabel: 'Mapa de conciliação'
  },
  {
    id: 'inspector-doc', name: 'Inspector Doc', shortName: 'Inspector Doc', icon: 'FileScan', accent: 'gold', category: 'Documentos',
    tagline: 'Documentos confiáveis, decisões defensáveis.',
    description: 'Analisa facturas, recibos, guias e imagens para localizar campos ausentes, incoerências e indícios de alteração.',
    features: ['Leitura de imagem e PDF', 'Checklist de integridade', 'Cadeia de evidência'],
    promptStarters: ['Verifique a integridade formal deste documento', 'Extraia os pontos que exigem confirmação humana', 'Crie um checklist de evidências complementares'],
    accepted: '.pdf,.png,.jpg,.jpeg,.webp,.txt,.md', outputLabel: 'Ficha de integridade'
  },
  {
    id: 'folha-segura', name: 'Folha Segura', shortName: 'Folha Segura', icon: 'UsersRound', accent: 'violet', category: 'Trabalho',
    tagline: 'Folhas salariais sem pontos cegos.',
    description: 'Audita consistência entre remunerações, descontos, IRT, segurança social e variações mensais.',
    features: ['Variação salarial', 'Sinais de omissão', 'Revisão IRT/INSS configurável'],
    promptStarters: ['Detecte variações salariais fora do padrão', 'Compare descontos e remunerações declaradas', 'Gere perguntas para a equipa de recursos humanos'],
    accepted: '.csv,.json,.txt,.md,.pdf', outputLabel: 'Relatório de folha'
  },
  {
    id: 'audittrail-lab', name: 'AuditTrail Lab', shortName: 'AuditTrail', icon: 'Route', accent: 'coral', category: 'Auditoria',
    tagline: 'Cada conclusão ligada à sua prova.',
    description: 'Constrói papéis de trabalho, amostras e uma linha temporal imutável de decisões e evidências.',
    features: ['Amostragem orientada a risco', 'Linha temporal', 'Conclusão por evidência'],
    promptStarters: ['Desenhe uma amostra baseada em risco', 'Identifique lacunas nesta cadeia de evidência', 'Redija a conclusão com ressalvas explícitas'],
    accepted: '.csv,.json,.txt,.md,.pdf,.png,.jpg,.jpeg', outputLabel: 'Papel de trabalho'
  },
  {
    id: 'contrato-claro', name: 'Contrato Claro', shortName: 'Contrato Claro', icon: 'FileKey2', accent: 'blue', category: 'Jurídico',
    tagline: 'Obrigações visíveis antes da assinatura.',
    description: 'Transforma contratos e propostas em obrigações, riscos, marcos, pagamentos e perguntas de negociação.',
    features: ['Matriz de obrigações', 'Alertas de ambiguidade', 'Resumo para decisão'],
    promptStarters: ['Mapeie obrigações, prazos e penalidades', 'Localize ambiguidades que exigem validação jurídica', 'Prepare perguntas para negociação'],
    accepted: '.pdf,.txt,.md,.json', outputLabel: 'Matriz contratual'
  },
  {
    id: 'pme-twin', name: 'PME Twin', shortName: 'PME Twin', icon: 'Orbit', accent: 'emerald', category: 'Estratégia',
    tagline: 'Um gémeo financeiro para testar o futuro.',
    description: 'Simula caixa, cobrança, custos e choques para transformar incerteza em cenários accionáveis.',
    features: ['Cenários de caixa', 'Stress test', 'Alavancas de decisão'],
    promptStarters: ['Crie três cenários de tesouraria', 'Mostre o impacto de receber 30 dias mais tarde', 'Identifique as duas melhores alavancas de caixa'],
    accepted: '.csv,.json,.txt,.md', outputLabel: 'Cenário financeiro'
  },
  {
    id: 'cliente-radar', name: 'Cliente Radar', shortName: 'Cliente Radar', icon: 'ContactRound', accent: 'gold', category: 'Risco',
    tagline: 'Conheça o risco sem perder a oportunidade.',
    description: 'Estrutura diligência, capacidade de pagamento, documentação e próximos passos para clientes empresariais.',
    features: ['Dossier KYC', 'Score explicável', 'Plano de diligência'],
    promptStarters: ['Crie um plano de diligência proporcional ao risco', 'Liste os documentos ainda necessários', 'Resuma os sinais positivos e as reservas'],
    accepted: '.pdf,.csv,.json,.txt,.md,.png,.jpg,.jpeg', outputLabel: 'Dossier de cliente'
  },
  {
    id: 'regulatorio-copilot', name: 'Regulatório Copilot', shortName: 'Regulatório', icon: 'Landmark', accent: 'violet', category: 'Conformidade',
    tagline: 'Mudança normativa convertida em trabalho.',
    description: 'Compara normas e comunicados fornecidos, identifica impacto e cria um plano de implementação verificável.',
    features: ['Comparação de versões', 'Mapa de impacto', 'Plano de implementação'],
    promptStarters: ['Compare estas duas versões e resuma alterações', 'Converta a norma em tarefas por área', 'Aponte o que precisa de confirmação na fonte oficial'],
    accepted: '.pdf,.txt,.md,.json', outputLabel: 'Nota de impacto'
  },
  {
    id: 'dossier-executivo', name: 'Dossier Executivo', shortName: 'Dossier', icon: 'BriefcaseBusiness', accent: 'coral', category: 'Relatórios',
    tagline: 'Da evidência à decisão, sem ruído.',
    description: 'Consolida análises e ficheiros num relatório executivo com riscos, decisões, responsáveis e próximos marcos.',
    features: ['Síntese multi-fonte', 'Plano de acção', 'Narrativa para direcção'],
    promptStarters: ['Crie um resumo executivo de uma página', 'Consolide riscos por prioridade e responsável', 'Transforme as conclusões em plano de 30 dias'],
    accepted: '.pdf,.csv,.json,.txt,.md,.png,.jpg,.jpeg', outputLabel: 'Dossier executivo'
  }
];

export const moduleById = (id?: string) => modules.find((item) => item.id === id);
